<template>
  <div class="vx-card">
    <!--------Proje Üst Kartlar------------>
    <h1 class="card-bg p-6 text-center mt-4">PROJE YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchProject = !showSearchProject">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6"/></span><span>Proje Arama</span>
        </h2>

        <div v-if="showSearchProject" class="card-bg p-5">
          <form @submit.prevent="GetHRProject()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Proje Adı</b></label>
                <vs-input size="large" type="text" style="width: 100%;" v-model="projectSearch.name" placeholder="Proje Adı" />
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Projeyi Oluşturan</b></label>
                <v-select @input="GetHRProject()" name="userId" v-model="projectSearch.userId" placeholder="Projeyi Oluşturan" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Departman</b></label>
                <v-select @input="GetHRProject()" name="departmanId" :disabled="1 == 2" v-model="projectSearch.departmentId" placeholder="Departman" :options="departmentList" label="departmentName" class="w-full" :reduce="(row) => row.departmentId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="flex-1 mb-5">
                <label class="text-sm mb-5"><b>Görev Atanan Projeler</b></label>
                <v-select @input="GetHRProject()" name="assignUserId" v-model="projectSearch.assignUserId" placeholder="Projeye Atanan" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="flex-1 mb-5">
                <label class="text-sm mb-5"><b>Projeyi Yöneticisi</b></label>
                <v-select @input="GetHRProject()" name="userId" v-model="projectSearch.managerUserId" placeholder="Proje Yöneticisi" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <div class="labels tFlex gap-1-5 mb-3">
                <label class="tFlex tFlex_ai-c gap-05">
                  <input @change="GetHRProject()" class="vs-radio" type="radio" v-model="projectSearch.status" value="Active" />
                  <span class="radio">Aktif</span>
                </label>

                <label class="tFlex tFlex_ai-c gap-05">
                  <input @change="GetHRProject()" class="vs-radio" type="radio" v-model="projectSearch.status" value="Passive" />
                  <span class="radio">Pasif</span>
                </label>

                <label class="tFlex tFlex_ai-c gap-05">
                  <input @change="GetHRProject()" class="vs-radio" type="radio" v-model="projectSearch.status" value="Completed" />
                  <span class="radio">Tamamlanmış</span>
                </label>
              </div>

              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>
      <div class="right mb-5">
        <h2 class="mb-3 card-bg text-center hoverHeading proje_card p-6" @click="showAddProject = !showAddProject">
          <span class="mr-2"><feather-icon icon="EditIcon" svgClasses="h-6 w-6"/></span><span>Proje Oluştur</span>
        </h2>
        <div v-if="showAddProject" class="card-bg p-5">
          <div class="projects tFlex gap-1 mb-3">
            <div class="left flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Proje Adı</b></label>
                <vs-input type="text" style="width: 100%;" v-model="projectItem.name" placeholder="Proje Adı" />
              </div>

              <div class="mb-5">
                <label class="text-sm"><b>Departman</b></label>
                <v-select name="departmentSelection" v-model="projectItem.departmentId" placeholder="Departman" :options="departmentList" label="departmentName" :reduce="(row) => row.departmentId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>

              <div class="mb-5">
                <label class="text-sm mb-1"><b>Proje Yöneticisi</b></label>
                <v-select name="userId" v-model="projectItem.managerUserId" placeholder="Proje Yöneticisi" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
            <div class="right flex-1">
              <div class="dates mb-5 tFlex gap-1">
                <div class="date">
                  <label class="text-sm"><b>Hedeflenen Başlangıç</b></label>
                  <DatePicker v-model="projectItem.startDate" valueType="format"></DatePicker>
                </div>
                <div class="date">
                  <label class="text-sm"><b>Hedeflenen Bitiş</b></label>
                  <DatePicker v-model="projectItem.finishDate" valueType="format"></DatePicker>
                </div>
              </div>

              <label class="text-sm"><b>Proje Açıklaması</b></label>
              <vs-textarea rows="4" v-model="projectItem.description" name="description" />
            </div>
          </div>

          <div class="tFlex tFlex_jc-c">
            <vs-button color="success" class="width-110" @click="SaveProject(projectItem, 'Insert', '')">Proje Ekle</vs-button>
          </div>
        </div>
      </div>
    </div>
    <!--------Proje Üst Kartlar Son------------>
    <!--------Proje Listesi------------>
    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6"/></span><span>Projeler</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="projectList">
            <template slot="thead">
              <vs-th width="50px">Id</vs-th>
              <vs-th width="150px">Proje Adı</vs-th>
              <vs-th width="150px">Departman</vs-th>
              <vs-th width="10px">Durum</vs-th>
              <vs-th width="150px">Oluşturan</vs-th>
              <vs-th width="150px">Yöneticisi</vs-th>
              <vs-th width="150px">Hedef Başlangıç</vs-th>
              <vs-th width="150px">Hedef Bitiş</vs-th>
              <vs-th width="150px">Gerçekleşen Başlangıç</vs-th>
              <vs-th width="150px">Gerçekleşen Bitiş</vs-th>
              <!-- <vs-th width="350px">Proje Açıklama</vs-th> -->
              <vs-th width="350px">İşlemler</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="tr.hrProjectId" v-for="(tr, i) in data" style="vertical-align: top;">
                <template v-if="tr.hrProjectId">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ tr.hrProjectId }}</b>
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <vs-input type="text" style="width: 150px;" v-model="tr.name" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <v-select name="departmentSelection" v-model="tr.departmentId" placeholder="Departman" :options="departmentList" label="departmentName" :reduce="(row) => row.departmentId">
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <v-select name="departmentSelection" v-model="tr.status" placeholder="Department" :options="statusList" label="name" :reduce="(row) => row.name">
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <vs-input readonly="true" type="text" style="width: 150px;" v-model="tr.userName" />
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <v-select name="userId" v-model="tr.managerUserId" placeholder="Proje Yöneticisi" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <DatePicker v-model="tr.startDate" valueType="format" style="width: 150px;"></DatePicker>
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <DatePicker v-model="tr.finishDate" valueType="format" style="width: 150px;"></DatePicker>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <DatePicker v-model="tr.actualStartDate" valueType="format" style="width: 150px;"></DatePicker>
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <DatePicker v-model="tr.actualFinishDate" valueType="format" style="width: 150px;"></DatePicker>
                  </vs-td>
                  <!-- <vs-td class="pt-0 pb-1">
                    <vs-textarea rows="2" cols="60" v-model="tr.description" name="description" />
                  </vs-td> -->

                  <td>
                    <a href="" @click.prevent="SaveProject(tr, 'Delete', 'Proje silinecek ve ekli dosya var ise bir daha erişilemeyecektir.')" style="font-size: 10px;"><b class="mr-5 success">Sil</b></a>
                    <a href="" @click.prevent="SaveProject(tr, 'Update', '')" style="color: orange; font-size: 10px;"><b class="mr-5">Güncelle</b></a>
                    <a
                      href=""
                      @click.prevent="
                        popupDetailAndFile = true;
                        selectedProjectItem = tr;
                      "
                      style="font-size: 10px;"
                      ><b class="mr-5 primary" style="white-space: nowrap;">Detay & Dosya</b></a
                    >
                    <a
                      href=""
                      @click.prevent="
                        selectedProjectItem = tr;
                        GetHRProjectAssign();
                        popupAssignment = true;
                      "
                      style="color: darkgray; font-size: 10px;"
                      ><b class="mr-5" style="white-space: nowrap;">Görevler</b></a
                    >
                  </td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>

    <!--------Proje Listesi Son------------>

    <vs-prompt
      style="z-index: 100001;"
      :vs-title="'Proje Detayı ve Dosya İşlemleri # ' + selectedProjectItem.hrProjectId"
      vs-accept-text="Kaydet"
      vs-cancel-text="Kapat"
      vs-button-cancel="border"
      :vs-active.sync="popupDetailAndFile"
      :vs-buttons-hidden="true"
      @vs-cancel="popupDetailAndFile = false"
    >
      <div class="vx-row w-full" style="justify-content: center; text-align: center;">
        <div class="vx-col mb-5">
          <label class="text-sm"><b>Projenin Detaylı Açıklaması</b></label>

          <vs-textarea rows="2" cols="160" v-model="selectedProjectItem.description" name="description" />
        </div>
      </div>

      <div class="vx-row w-full" style="justify-content: center;">
        <div class="vx-col mb-5">
          <b>DOSYA İŞLEMLERİ</b>
        </div>
      </div>

      <div class="vx-row w-full" style="justify-content: center;">
        <div class="vx-col mb-5">
          <input type="file" @change="$event.target.files != null && Object.keys($event.target.files).length > 0 ? addFiles($event) : null" />

          <!-- <progress v-if="fileUploadIsInProgress" class="block mt-1" max="100" style="width:500px;color:red" ></progress> -->
        </div>
      </div>

      <div class="vx-row w-full mb-5" v-if="$store.state.userData.departmentId == selectedProjectItem.departmentId">
        <div class="vx-row w-full">
          <div class="vx-col w-full">
            <vs-table search v-if="selectedProjectItem.fileList" :maxItems="10" :pagination="true" :data="selectedProjectItem.fileList">
              <template slot="thead">
                <vs-th>Id</vs-th>
                <vs-th>Dosya Adı</vs-th>
                <vs-th>Version</vs-th>
                <vs-th>Dosya Açıklaması</vs-th>
                <vs-th>Boyut</vs-th>
                <vs-th>Oluşturan</vs-th>
                <vs-th>Eklenme Tarihi</vs-th>
                <vs-th>Erişim Sayı</vs-th>
                <vs-th>Son Erişen</vs-th>
                <vs-th>İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.hrProjectFileId" v-for="(tr, i) in data">
                  <template>
                    <vs-td class="">
                      <b>{{ tr.hrProjectFileId }}</b>
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <vs-input readonly="true" style="width: 290px;" type="text" v-model="tr.name" />
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      {{tr.version}}
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <vs-input style="width: 250px;" readonly="true" type="text" v-model="tr.description" />
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      {{tr.size}}
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <vs-input style="width: 100px;" readonly="true" type="text" v-model="tr.userName" />
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <DatePicker style="width: 150px;" v-model="tr.date" valueType="format"></DatePicker>
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                       {{tr.accessCount}}
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <vs-input style="width: 100px;" readonly="true" type="text" v-model="tr.accessUserName" />
                    </vs-td>
                    <td>
                      <div style="flex-flow: nowrap; width: max-content;">
                        <feather-icon
                          icon="TrashIcon"
                          v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '15') != null"
                          title="Sil"
                          svgClasses="h-5 mr-5 hover:text-danger cursor-pointer"
                          @click="DeleteFile(tr, 'DeleteFile', tr.name + ' isimli dosya sistemden kalıcı olarak silinecektir.')"
                        />
                        <feather-icon icon="DownloadIcon" title="Download" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="DownloadFile(tr)" />
                        <feather-icon v-if="1==2" icon="EditIcon" title="Güncelle" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="UpdateFileInfo(tr)" />
                      </div>
                    </td>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-prompt>

    <vs-prompt
      style="z-index: 100001;"
      :vs-title="'Proje Görev Atama İşlemleri # ' + selectedProjectItem.hrProjectId + ' # ' + selectedProjectItem.name"
      vs-accept-text="Kaydet"
      vs-cancel-text="Kapat"
      vs-button-cancel="border"
      :vs-active.sync="popupAssignment"
      :vs-buttons-hidden="true"
      @vs-cancel="popupAssignment = false"
    >
      <div class="vx-row w-full">
        <div class="vx-col mb-5" style="width: 350px;">
          <label class="text-sm"><b>Atanacak Personel</b></label>
          <v-select name="assignUserId" v-model="projectAssignItem.assignUserId" placeholder="Görev Kişi" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>

        <div class="vx-col mb-5" style="width: 350px;">
          <label class="text-sm"><b>Görev Dosyası</b></label>
          <v-select
            v-if="selectedProjectItem.fileList"
            name="hrProjectFileId"
            v-model="projectAssignItem.hrProjectFileId"
            placeholder="Görev Dosyası"
            :options="selectedProjectItem.fileList"
            label="name"
            class="w-full"
            :reduce="(row) => row.hrProjectFileId"
          >
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
      </div>

      <div class="vx-row w-full">
        <div class="vx-col mb-5 w-full md:w-4/4">
          <label class="text-sm"><b>Görev Açıklaması</b></label>
          <vs-textarea rows="1" v-model="projectAssignItem.description" name="description" />
        </div>
      </div>

      <div class="vx-row w-full mb-5" style="justify-content: center;">
        <vs-button
          color="danger"
          @click="
            projectAssignItem.assignStatus = 'Assigned';
            SaveHRProjectAssign(projectAssignItem, 'Insert', 'Görev ataması yapılacak ve atanan kişi mail ile bilgilendirilecektir.');
          "
          >Görev Ekle</vs-button
        >
      </div>

      <div class="vx-row w-full mb-5">
        <div class="vx-row w-full">
          <div class="vx-col w-full">
            <vs-table search v-if="projectAssignList" :maxItems="10" :pagination="true" :data="projectAssignList">
              <template slot="thead">
                <vs-th>Id</vs-th>
                <vs-th>Atayan</vs-th>
                <vs-th>Atanan</vs-th>
                <vs-th>Görev Açıklama</vs-th>
                <vs-th>Atama Tarih</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Dosya Adı</vs-th>
                <vs-th>Görev Başlama</vs-th>
                <vs-th>Görev Bitirme</vs-th>
                <vs-th>İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.hrProjectAssignId" v-for="(tr, i) in data">
                  <template>
                    <vs-td class="">
                      <b>{{ tr.hrProjectAssignId }}</b>
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <vs-input style="width: 100px;" readonly="true" type="text" v-model="tr.userName" />
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <vs-input style="width: 100px;" readonly="true" type="text" v-model="tr.assignUserName" />
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <vs-input style="width: 100px;" readonly="true" type="text" v-model="tr.description" />
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <DatePicker style="width: 120px;" disabled v-model="tr.date" valueType="format"></DatePicker>
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <v-select name="statusSelection" disabled v-model="tr.assignStatus" placeholder="Status" :options="assignStatusList" label="name" :reduce="(row) => row.name">
                        <span slot="no-options">Eşleşen Veri Yok</span>
                      </v-select>
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <vs-input style="width: 70px;" readonly="true" type="text" v-model="tr.fileName" />
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <DatePicker style="width: 120px;" disabled v-model="tr.startDate" valueType="format"></DatePicker>
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <DatePicker style="width: 120px;" disabled v-model="tr.finishDate" valueType="format"></DatePicker>
                    </vs-td>
                    <td>
                      <div style="flex-flow: nowrap; width: max-content;">
                        <template v-if="tr.assignUserId == $store.state.userData.userId">
                          <a v-if="tr.assignStatus == 'Assigned'" href="" @click.prevent="SaveHRProjectAssign(tr, 'Delete', '')" style="color: red; font-size: 10px;"><b class="mr-5">Sil</b></a>
                          <!-- <a href="" @click.prevent="SaveHRProjectAssign(tr, 'Update', '')" style="color: orange; font-size: 10px;"><b class="mr-5">Güncelle</b></a> -->
                          <!-- <a href="" @click.prevent="SaveHRProjectAssign(tr, 'Update', '')" style="color: black; font-size: 10px;"><b class="mr-5">Log</b></a> -->
                          <a
                            v-if="tr.assignStatus == 'Assigned'"
                            href=""
                            @click.prevent="
                              tr.assignStatus = 'Completed';
                              tr.finishDate = $moment().format('l LT');
                              SaveHRProjectAssign(tr, 'Update', 'Görev taskı tamamlanacak atayan kişi mail ile bilgilendirilecektir.');
                            "
                            style="color: #7393b3; font-size: 10px;"
                            ><b class="mr-5">Tamamla</b></a
                          >
                        </template>
                      </div>
                    </td>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      userList: [],
      // versionList: [{name:1, value:1},{name:2, value:2},{name:3, value:3},{name:4, value:4},{name:5, value:5},{name:6, value:6},{name:7, value:7},{name:8, value:8},{name:9, value:9}],
      selectedProjectAssignItem: {},
      projectAssignItem: { assignUserId: null, description: null, hrProjectFileId: null },
      projectAssignList: [{ hrProjectId: null, projectName: null, departmentId: null, fileList: [], finishData: null, startData: null }],

      popupDetailAndFile: false,
      popupAssignment: false,
      departmentList: [],
      projectItem: { status: "Active", hrProjectId: null, projectName: null, departmentId: null, fileList: [] },
      projectSearch: { userId: null, status: "Active", hrProjectId: null, projectName: null, departmentId: null, fileList: [], assignUserId: null },
      selectedProjectItem: {},
      projectList: [{ hrProjectId: null, projectName: null, departmentId: null, fileList: [] }],

      statusList: [{ name: "Active" }, { name: "Completed" }],
      assignStatusList: [{ name: "Assigned" }, { name: "Completed" }],
      showAddProject: false,
      showSearchProject: false,
    };
  },

  computed: {},
  methods: {
    getUsers: async function() {
      this.userList = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) => r.list);
    },

    addFiles: async function(event) {
      /*

      let fileInAlreadyList = this.selectedProjectItem.fileList;

      if (fileInAlreadyList == null) fileInAlreadyList = [];
      console.log(Object.keys(fileInAlreadyList));
      if (Object.keys(fileInAlreadyList).length > 0) {
        fileInAlreadyList = fileInAlreadyList.filter((r) => {
          return r.name == this.selectedProjectItem.hrProjectId + "_" + event.target.files[0].name;
        });
      }


      //yetki yoksa aynı isimli dosya tekrar upload yapılamayacak
      if (this.$store.state.userData.authorizationList.find((f) => f.authorizationId == "15") != null || Object.keys(fileInAlreadyList).length == 0) {
        null;
      } else {
        await this.$swal.fire({
          icon: "warning",
          //title: "Ekleyeceğiniz dosya hakkında kısa açıklama giriniz",
          text: "Sistemde aynı isimde bir dosya mevcut. Bu sebeple yetkisiz tekrar upload yapılamaz.",
          //input: "text",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "İptal",
        });
        event.target.files = null;
        return;
      }
      // Yetki varsa overwrite oluyorsa uyarı verilmeli
      if (Object.keys(fileInAlreadyList).length == 0) {
        null;
      } else {
        let resultConfirmForOverwrite = await this.$swal.fire({
          icon: "warning",
          title: "Devam etmek istediğinize emin misiniz?",
          text: "Aynı isimde önceden yüklenmiş dosya vardır. Mevcut dosyanın üzerine yazılacaktır.",
          //input: "text",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });
        if (resultConfirmForOverwrite.isConfirmed) null;
        else return;
      }

*/

      let resultConfirm = await this.$swal.fire({
        icon: "warning",
        //title: "Ekleyeceğiniz dosya hakkında kısa açıklama giriniz",
        text: "Lütfen ekleyeceğiniz dosya hakkında kısa açıklama giriniz",
        input: "text",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm.isConfirmed) {
        this.$vs.loading();

        await repository.postFileWithModuleId("HumanResource/CreateHumanResourceFile", event.target.files, "_files", this.selectedProjectItem.hrProjectId, resultConfirm.value);

        this.$vs.loading.close();

        this.selectedProjectItem = await this.GetHRProjectById(this.selectedProjectItem.hrProjectId);
      }
    },

    getDepartment: async function() {
      this.departmentList = await repository.getAll("HumanResource/getDepartment").then((r) => r.list);
    },

    GetHRProject: async function() {
      this.$vs.loading();
      this.projectList = await repository.postEntity("HumanResource/GetHRProject", this.projectSearch).then((r) => r.list);
      this.$vs.loading.close();
    },

    GetHRProjectById: async function(hrProjectId) {
      return await repository.postEntity("HumanResource/GetHRProject", { hrProjectId: hrProjectId }).then((r) => r.list[0]);
    },

    SaveProject: async function(item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("HumanResource/SaveHRProject", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.projectItem = {};

      this.GetHRProject();
    },

    GetHRProjectAssign: async function() {
      this.$vs.loading();
      this.projectAssignList = await repository.postEntity("HumanResource/GetHRProjectAssign", this.selectedProjectItem).then((r) => r.list);
      this.$vs.loading.close();
    },

    SaveHRProjectAssign: async function(item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;
      item.hrProjectId = this.selectedProjectItem.hrProjectId;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("HumanResource/SaveHRProjectAssign", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.GetHRProjectAssign();
    },

    DeleteFile: async function(item, operation, messageText) {
      console.log(item);

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      let list = [item];

      await repository.postEntity("HumanResource/DeleteHRProjectFile", list);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.selectedProjectItem = await this.GetHRProjectById(this.selectedProjectItem.hrProjectId);
    },

    UpdateFileInfo: async function(item) {
      console.log(item);

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      let list = [item];

      await repository.postEntity("HumanResource/DeleteHRProjectFile", list);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.selectedProjectItem = await this.GetHRProjectById(this.selectedProjectItem.hrProjectId);
    },

    DownloadFile: async function(item, operation, messageText) {
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      let list = [item];
      // await repository.postEntity("HumanResource/DownloadHRProjectFile", list);
      await repository
        .DownloadStream("HumanResource/DownloadHRProjectFileGet" + "/" + item.hrProjectId + "/" + item.hrProjectFileId + "/" + item.name)
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = item.name;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); //afterwards we remove the element again
        });

      //  "searchQuery=" + "CustomerId=" + this.owedCustomerSearchQuery

      this.$vs.loading.close();

      // await this.$swal.fire({
      //   icon: "success",
      //   title: "İşlem Başarılı",
      //   //text: "",
      //   showCancelButton: false,
      //   confirmButtonColor: "#3085d6",
      //   cancelButtonColor: "#d33",
      //   confirmButtonText: "Tamam",
      //   cancelButtonText: "Hayır",
      // });

      this.selectedProjectItem = await this.GetHRProjectById(this.selectedProjectItem.hrProjectId);
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (this.popupDetailAndFile) this.popupDetailAndFile = false;
        if (this.popupAssignment) this.popupAssignment = false;
      }
    });
  },
  created: async function() {
    this.$vs.loading();

    if (this.$route.params != null && this.$route.name == "HRProjectById" && this.$route.params.hrProjectId > 0) {
      this.projectSearch.hrProjectId = this.$route.params.hrProjectId;
      this.projectSearch.status=null;
    } else if (this.$route.params != null && this.$route.name == "HRProjectByAssignUserId" && this.$route.params.assignUserId > 0) {
      this.projectSearch.assignUserId = Number(this.$route.params.assignUserId);
      this.projectSearch.status=null;
    }

    await Promise.all([this.getDepartment(), this.getUsers(), this.GetHRProject()]);

    this.$vs.loading.close();
  },
};
</script>

<style lang="scss" scope>
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1600px !important;
  max-height: 95% !important;
}
</style>
